import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-41116a12")

_pushScopeId("data-v-41116a12")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "symbol symbol-45px custom" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { style: {"font-size":"smaller"} }
const _hoisted_5 = { style: {"font-size":"smaller"} }
const _hoisted_6 = { style: {"font-size":"smaller"} }
const _hoisted_7 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_8 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
const _hoisted_10 = { class: "menu-item-wrapper" }
const _hoisted_11 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" })
], -1)
const _hoisted_13 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-clipboard-list" })
], -1)
const _hoisted_15 = {
  key: 2,
  class: "menu-item"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-user-cog" })
], -1)
const _hoisted_17 = {
  key: 3,
  class: "menu-item"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_AdvanceSearch = _resolveComponent("AdvanceSearch")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, { loading: _ctx.loading }, null, 8, ["loading"]),
    _createVNode(_component_AdvanceSearch, {
      filter: true,
      selectData: _ctx.filterObject,
      filterOption: _ctx.filterOption,
      sites: _ctx.sites,
      status: _ctx.statusList,
      customer_group: _ctx.customerGroupList,
      onLoadCategory: _ctx.loadCategory,
      filterPlaceholder: 'message.SELECT',
      onSearch: _ctx.searchHandler,
      inputPlaceholder: "message.ENTER_KEY_TO_SEARCH",
      onReloadListing: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getCustomers(1, true))),
      onExportFile: _ctx.exportFile
    }, null, 8, ["selectData", "filterOption", "sites", "status", "customer_group", "onLoadCategory", "filterPlaceholder", "onSearch", "onExportFile"]),
    _createVNode(_component_Table, {
      loading: _ctx.loader,
      columns: _ctx.columns,
      rows: _ctx.customers,
      pagination: _ctx.pagination,
      padding: 2,
      onHandleCurrentChange: _ctx.handleCurrentChange,
      onSorting: _ctx.searchHandler
    }, {
      "cell-avatar": _withId(({ row: item }) => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            class: "navatar",
            style: 'background-color:' + _ctx.generateAvatar(item?.user?.name)?.color
          }, [
            _createVNode("span", null, _toDisplayString(_ctx.generateAvatar(item?.user?.name)?.name), 1)
          ], 4)
        ])
      ]),
      "cell-name": _withId(({ row: item }) => [
        (_ctx.$can('view_customer'))
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode("a", {
                onClick: ($event: any) => (_ctx.handleView(item))
              }, [
                _createTextVNode(_toDisplayString(item?.user?.name) + " ", 1),
                _createVNode("p", _hoisted_4, _toDisplayString(item?.user?.email), 1)
              ], 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      "cell-roles": _withId(({ row: item }) => [
        _createTextVNode(_toDisplayString(item?.user?.roles) + " ", 1),
        _createVNode("p", _hoisted_5, _toDisplayString(item?.parent ? '(Customer : ' + item?.parent?.name + ')' : ''), 1)
      ]),
      "cell-economic_number": _withId(({ row: item }) => [
        _createTextVNode(_toDisplayString(item?.economic_number ? item?.economic_number : item?.user?.roles == 'manager' ? item?.parent?.customer?.economic_number : 'N/A') + " ", 1),
        _createVNode("p", _hoisted_6, _toDisplayString(item?.parent?.customer?.economic_number ? '(Customer Economic Number)' : ''), 1)
      ]),
      "cell-customer_group": _withId(({ row: item }) => [
        _createTextVNode(_toDisplayString(item?.customer_group?.name), 1)
      ]),
      "cell-status": _withId(({ row: item }) => [
        (item?.user?.status == 1)
          ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('message.ACTIVE')), 1))
          : (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('message.INACTIVE')), 1))
      ]),
      "cell-actions": _withId(({ row: item }) => [
        _createVNode("button", {
          class: "action-btn",
          type: "button",
          onClick: ($event: any) => (_ctx.dropdownHandler(_ctx.activeIndex, item?.id))
        }, [
          _hoisted_9,
          _createVNode("div", {
            class: ["dropdown-menu dropdown-menu-end action-dropdown", { active: _ctx.activeIndex === item?.id }]
          }, [
            _createVNode("div", _hoisted_10, [
              (_ctx.$can('edit_customer'))
                ? (_openBlock(), _createBlock("div", _hoisted_11, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.handleEdit(item)),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_12,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.EDIT')), 1)
                    ], 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$can('view_customer'))
                ? (_openBlock(), _createBlock("div", _hoisted_13, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.handleView(item)),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_14,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.VIEW')), 1)
                    ], 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$can('login_as_customer'))
                ? (_openBlock(), _createBlock("div", _hoisted_15, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.handleLoginAs(item)),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_16,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.LOGIN_AS')), 1)
                    ], 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$can('delete_customer'))
                ? (_openBlock(), _createBlock("div", _hoisted_17, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.handleDelete(item.id)),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_18,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.DELETE')), 1)
                    ], 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ], 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["loading", "columns", "rows", "pagination", "onHandleCurrentChange", "onSorting"])
  ]))
})